import { createBrowserRouter } from 'react-router-dom';

// routes
import DashboardRoutes from './dashboard-routes';
//import config from 'config';

// ==============================|| ROUTING RENDER ||============================== //

const AppRoutes = createBrowserRouter([DashboardRoutes]);
export default AppRoutes;
